<ui-modal modalTitle="Select Job" size="xl" [scrollable]="true" [fullHeight]="true" [embed]="embed" [header]="jobsAvailableInBookingMode()" [footer]="jobsAvailableInBookingMode()">
	<div *ngIf="jobsAvailableInBookingMode()" class="d-flex align-items-center flex-wrap mr-3" ui-modal-header>
		<ng-container *ngIf="filterList">
			<div class="flex-weight-1"></div>
			<div *ngIf="isAnyFilterActive()" class="icon-clear-filters px-2 mr-3 selectable" (click)="clearAllFilters()">
				<i class="wq wq-refresh "></i>
			</div>
			<div *ngIf="projectList.length && projectId === null" class="mr-3 w-7r">
				<ui-checkbox-dropdown dropdownName="Project" [items]="projectList" [selectedItems]="service.projectFilter" [selectProp]="'id'" (selectionChange)="handleSelectionChange($event, 'project')"></ui-checkbox-dropdown>
			</div>
			<div *ngIf="systemList.length" class="mr-3 w-7r">
				<ui-checkbox-dropdown dropdownName="System" [items]="systemList" [selectedItems]="service.systemFilter" [selectProp]="'id'" (selectionChange)="handleSelectionChange($event, 'system')"></ui-checkbox-dropdown>
			</div>
			<!-- <div *ngIf="teamList.length" class="mr-3 w-7r">
				<ui-checkbox-dropdown dropdownName="Team" [items]="teamList" [selectedItems]="service.teamFilter" [selectProp]="'id'" (selectionChange)="handleSelectionChange($event, 'team')"></ui-checkbox-dropdown>
			</div> -->
			<div *ngIf="userList.length" class="mr-3 w-7r">
				<ui-checkbox-dropdown dropdownName="User" [items]="userList" [selectedItems]="service.userFilter" [selectProp]="'id'" (selectionChange)="handleSelectionChange($event, 'user')"></ui-checkbox-dropdown>
			</div>
			<div *ngIf="labelList.length" class="mr-3 w-7r">
				<ui-checkbox-dropdown dropdownName="Label" [items]="labelList" [selectedItems]="service.labelFilter" [selectProp]="'id'" (selectionChange)="handleSelectionChange($event, 'label')"></ui-checkbox-dropdown>
			</div>
			<div *ngIf="work_orders">
				<div class="input-group">
					<div class="input-group-prepend">
						<span class="input-group-text"><i class="wq wq-search"></i></span>
					</div>
					<input type="search" class="form-control" placeholder="Search" [(ngModel)]="workOrderSearchList" (ngModelChange)="refreshList(500)" autocomplete="chrome-off" spellcheck="false" appDesktopFocus>
				</div>
			</div>
		</ng-container>
		<button *ngIf="mode === 'book' && type && type === 'service_job'" class="btn btn-primary ml-2" (click)="newServiceJob()">New Service Job</button>
	</div>

	<div *ngIf="jobsAvailableInBookingMode()" class="d-flex mt-n4 sticky-tabs">
		<div *ngFor="let s of stageList" class="px-3 py-4 flex-weight-1 selectable hoverable border-bottom d-flex align-items-center border-{{service.stageColor(s, service.stageFilter === s, 'lightgrey')}}" [ngClass]="{ 'border-4': service.stageFilter === s }" style="height: 4.4rem;" (click)="selectStageFilter(s)">
			<span class="text-uppercase text-small text-bold mr-2" [ngClass]="{ 'text-secondary': service.stageFilter !== s }">{{service.stageDescription(s)}}</span>
			<span *ngIf="work_orders" class="badge badge-{{service.stageColor(s, service.stageFilter === s)}}">{{stageTotal(s)}}</span>
		</div>
	</div>

	<table *ngIf="work_orders && jobsAvailableInBookingMode()" class="table table-hover">
		<thead>
			<tr class="sticky">
				<th class="selectable sticky" (click)="sortBy('work_order_no')">#<i class="{{sortClass('work_order_no')}}"></i></th>
				<th class="selectable sticky" (click)="sortBy('customer_name')">Customer Name <i class="{{sortClass('customer_name')}}"></i></th>
				<th class="selectable sticky" (click)="sortBy('name')">Job Name <i class="{{sortClass('name')}}"></i></th>
				<th class="sticky">Label</th>
				<th class="sticky">Team/User</th>
				<th class="selectable sticky text-right" (click)="sortBy('last_activity')">Last Activity <i class="{{sortClass('last_activity')}}"></i></th>
				<th class="sticky text-center shrink px-0">
					<div style="width: 1px; height: 16px; background-color: grey; margin-left: 9px; margin-right: 9px;">&nbsp;</div>
				</th>
				<th class="selectable sticky text-left" (click)="sortBy('next_allocation')">Next Booking <i class="{{sortClass('next_allocation')}}"></i></th>
				<th class="sticky text-center" style="max-width: 10rem;">Progress</th>
				<th class="sticky text-center">Tasks Completed</th>
				<th class="selectable sticky" (click)="sortBy('billable')">Billing Status <i class="{{sortClass('billable')}}"></i></th>
			</tr>
		</thead>
		<tbody>
			<tr *ngFor="let item of work_orders.list.result" class="selectable" (click)="selectItem(item)">
				<td class="text-secondary">{{item.work_order_no}}</td>
				<td>
					<div><b>{{item.customer_name}}</b></div>
					<div class="text-secondary">{{item.project}}</div>
				</td>
				<td>
					<span class="text-lines lines-1 text-bold" uiEllipsisTooltip style="max-width: 10rem;"><i class="mr-1 wq wq-booking-{{item.type === 'service' ? 'service' : 'project'}}"></i> {{item.name}}</span>
					<div class="text-capitalize">{{item.type}}</div>
					<div *ngIf="item.type === 'service'" class="badge badge-info mr-2 mt-1">Service Job</div>
					<div *ngIf="item.type !== 'service'" class="badge badge-danger mr-2 mt-1">Project Job</div>
				</td>
				<td>
					<ng-container *ngFor="let label_id of item.labels; let i = index">
						<div *ngIf="i < 2; else showMoreLabels">
							<ui-label [label_text]="getLabelData(label_id)?.text" [label_color]="getLabelData(label_id)?.label_color"></ui-label>
						</div>
						<ng-template #showMoreLabels>
							<div *ngIf="i === item.labels.length - 1">
								<span class="badge badge-secondary text-uppercase p-2" [ngbTooltip]="labelTooltip" style="background-color: #EDF0F3; font-size: 0.7rem; color: #000; margin-left: 2rem;">+{{ item.labels.length - 2 }}</span>
							</div>
							<ng-template #labelTooltip>
								<ng-container *ngFor="let labelid of item.labels; let j = index">
									<div *ngIf="j > 1" style="text-align: left;">
										<ui-label [label_text]="getLabelData(labelid)?.text" [label_color]="getLabelData(labelid)?.label_color"></ui-label>
									</div>
								</ng-container>
							</ng-template>
						</ng-template>
					</ng-container>
				</td>
				<td class="shrink">
					<div class="d-flex align-items-center" *ngIf="item.users?.length" [ngbTooltip]="allocationTooltip">
						<ng-container *ngFor="let user of item.users; let i = index">
							<ui-user-image *ngIf="i < 3" [email]="user.email" style="margin-left: -5px;" [title]="user.title"></ui-user-image>
						</ng-container>
						<div *ngIf="item.users.length > 3" class="extra-count">
							<span style="border-radius: 50%; color: #fff; padding: 0.45rem; margin-left: -5px;" class="bg-secondary">+{{ item.users.length - 3 }}</span>
						</div>
					</div>
				</td>
				<ng-template #allocationTooltip>
					<table class="mb-2" *ngFor="let allocation of item.users">
						<tr>
							<td class="text-left text-bold">{{allocation.title}}</td>
							<td></td>
							<td></td>
						</tr>
						<tr>
							<td class="text-left">Last worked</td>
							<td> - </td>
							<td class="text-center text-bold">{{allocation.last_clocked_in_datetime | mySQLDateToISO | localizedDate: 'shortDate'}}</td>
						</tr>
						<tr>
							<td class="text-left">Next Booking</td>
							<td> - </td>
							<td class="text-center text-bold">{{allocation.next_allocation_start_date | mySQLDateToISO | localizedDate: 'shortDate'}}</td>
						</tr>
					</table>
				</ng-template>
				<td class="text-right pr-0">
					<ng-container *ngIf="item.last_clocked_in_datetime; else noActivity">
						{{item.last_day_of_week}}
						{{item.last_clocked_in_datetime | mySQLDateToISO | localizedDate: 'shortDate'}}<br>
						<small class="text-secondary">{{item.activity_text}}</small>
					</ng-container>
					<ng-template #noActivity>
						<div class="text-muted mt-2 text-center">-</div>
					</ng-template>
				</td>
				<td class="text-center shrink px-0">
					<div style="width: 1px; height: 30px; background-color: grey; margin-left: 9px; margin-right: 9px;">&nbsp;</div>
				</td>
				<td class="text-left pl-0">
					<div *ngIf="item.next_allocation_start_date; else noAllocation" class="d-flex align-items-center">
						<div>
							{{item.next_day_of_week}} {{item.next_allocation_start_date | mySQLDateToISO | localizedDate:'shortDate'}}<br>
							<small class="text-secondary">{{item.next_allocation_text}}</small>
						</div>
					</div>
					<ng-template #noAllocation>
						<div class="text-muted mt-2 text-center">-</div>
					</ng-template>
				</td>
				<td class="text-center" style="max-width: 10rem;">
					<ui-task-progress-bar [item]="item" [simplifiedMode]="true"></ui-task-progress-bar>
				</td>
				<td>
					<div class="d-flex align-items-center no-wrap justify-content-center text-bold text-success">
						<div class="mr-2" style="font-size: 0.8rem;">
							<i class="wq wq-task text-success"></i> {{ item.completed_tasks || 0 }}/{{ item.total_tasks || 0 }}
						</div>
					</div>
					<div *ngIf="item.total_sub_tasks > 0" class="d-flex align-items-center no-wrap justify-content-center">
						<div class="mr-2 text-small text-secondary">
							{{ item.completed_sub_tasks || 0 }}/{{ item.total_sub_tasks || 0 }} Subtasks Completed
						</div>
					</div>
				</td>
				<td>
					<div class="badge badge-{{service.stageColor(item.stage)}}">{{service.stageDescription(item.stage)}}</div>
					<br>
					<div *ngIf="item.billable" class="badge badge-info mr-2 mt-1">Billable</div>
					<div *ngIf="!item.billable" class="badge badge-secondary mr-2 mt-1">Not Billable</div>
				</td>
			</tr>
			<tr *ngIf="!pagination.count">
				<td colspan="11" class="text-secondary">No jobs found.</td>
			</tr>
		</tbody>
	</table>

	<div *ngIf="jobsAvailableInBookingMode()" class="flex-weight-1" ui-modal-footer>
		<app-pagination [pagination]="pagination" (navigate)="refreshList(100)"></app-pagination>
	</div>
	<button *ngIf="!embed && jobsAvailableInBookingMode()" class="btn btn-secondary ml-3" (click)="modal.close()" ui-modal-footer>Cancel</button>
	<button *ngIf="mode === 'add' && jobsAvailableInBookingMode()" class="btn btn-primary ml-2" (click)="createNewWorkOrder()" ui-modal-footer>Create New Job</button>
	<div *ngIf="work_orders && !jobsAvailableInBookingMode()" class="w-100 h-100 d-flex align-items-center justify-content-center text-secondary">
		<div class="text-center">
			<div class="mb-2"><i class="wq wq-warning" style="font-size: 2rem;"></i></div>
			<div class="text-bold text-large mb-1">No jobs have been created for this Project/Customer</div>
			<div class="mb-2">Please create job to book it.</div>
			<button class="btn btn-primary" (click)="newJob()">New {{type === 'service_job' ? ' Service ' : ' Project '}} Job</button>
		</div>
	</div>
</ui-modal>

<modal-edit-work-order (close)="workOrderEditModalClosed($event)"></modal-edit-work-order>
